import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { QueryHistoryRecord } from 'src/app/core/services/feed.service';
import { SearchInputComponent } from '../../search-input/search-input.component';
import { SuiButtonComponent } from '@sui/button';
import { SuiPaginationComponent } from '@sui/pagination';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-query-history-viewer',
  templateUrl: './query-history-viewer.component.html',
  styleUrls: ['./query-history-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SearchInputComponent,
    SuiButtonComponent,
    SuiPaginationComponent,
    DatePipe,
    TranslatePipe,
  ],
})
export class QueryHistoryViewerComponent {
  @Input() historyRecords: QueryHistoryRecord[];

  currentPage: number = 1;
  pageSize: number = 5;
  totalRecords: number = 0;
  allRecords: any[] = [];
  paginatedRecords: any[] = [];
  filteredPaginatedRecords: any[] = [];
  searchQuery: string = '';

  @Output() onUpdateHistory = new EventEmitter<QueryHistoryRecord>();

  ngOnInit() {
    this.setupHistoryRecords();
  }

  ngOnChanges() {
    this.setupHistoryRecords();
  }

  setupHistoryRecords() {
    this.allRecords = this.historyRecords?.map((record) => ({
      ...record,
      expanded: false,
    }));
    this.totalRecords = this.historyRecords?.length;
    this.updatePage();
  }

  onPageChange(page: number | string) {
    if (typeof page === 'string') {
      page = parseInt(page, 10) || 1;
    }
    this.currentPage = page;
    this.updatePage();
  }

  private updatePage() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedRecords = this.allRecords?.slice(start, end);
    this.filteredPaginatedRecords = this.paginatedRecords;
  }

  toggleItemExpand(item: any) {
    if (item) {
      item.expanded = !item.expanded;
    }
  }

  getLineCount(query: string): number {
    return query?.split(/\r\n|\r|\n/).length || 0;
  }

  historyRecordClick(historyRecord: QueryHistoryRecord) {
    this.onUpdateHistory.emit(historyRecord);
  }

  onSearchChange(value: string) {
    this.searchQuery = value;
    if (value) {
      this.filteredPaginatedRecords = this.paginatedRecords.filter((item) =>
        item.query.toLowerCase().includes(value.toLowerCase()),
      );
    } else {
      this.setupHistoryRecords();
    }
  }
}
